<template>
<div id="company-select">
    <NavbarDefault selection />
    <div class="container p-5">
        <div class="row d-flex justify-content-end">

            <div class="col-12 mb-4">
                <h3 class="c-ndarkthree bold">
                    <CompanyIcon :color="getPrimaryColorHex.four" /> Empresas
                </h3>
                <p class="c-ndarkfour">
                    Selecione com qual das empresas deseja acessar a plataforma.
                </p>
            </div>
            <div class="col-12 d-flex align-items-center justify-content-end mb-3">
                <CompanyFilter
                    :statusFilter="false"
                    @filter="filter.companyType = $event.companyType; filter.companyPartner = $event.companyPartner"
                    @filterSearch="search = $event"
                    @emptyFilter="emptyFilter"
                    :economicGroupPartnerFilter="this.$store.state.user.userAdm"
                />
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <TableLoading v-if="isLoading" rowHeight="56" :tableHeader="false"/>
                <Company v-else-if="filteredTableData.length" :tableData="filteredTableData" />
                <NotFound v-else-if="search.length" />
                <EmptyEconomicGroup v-else
                    title="Você não está vinculado a nenhuma empresa."
                >
                    Para acessar a {{ getWhiteLabel | capitalizeFirstLetter }}, você precisa estar vinculado a alguma <br>
                    empresa da plataforma.
                </EmptyEconomicGroup>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Company from '@/components/tables/Company'
import CompanyFilter from '@/components/filters/CompanyFilter'
import getAllCnpjs from '@/api/getAllCnpjs'
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import removeMask from '@/utils/removeMask'
import TableLoading from '@/components/loading/TableLoading'
import Cookies from 'js-cookie'
import EmptyEconomicGroup from '@/components/emptyOrNotFound/EmptyEconomicGroup'

export default {
    components: {
        Company,
        CompanyFilter,
        NavbarDefault,
        NotFound,
        TableLoading,
        EmptyEconomicGroup
    },
    data() {
        return {
            filter: {
                companyType: '',
                companyPartner: ''
            },
            search: '',
            isLoading: false
        }
    },
    computed: {
        filteredTableData() {
            const { companys } = this.$store.state.user
            return companys
                .filter(this.companyTypeFilter)
                .filter(this.searchFilter)
                .filter(this.companyPartnerFilter)
        }
    },
    methods: {
        emptyFilter() {
            this.filter = {
                companyType: '',
                companyPartner: ''
            }
        },
        companyTypeFilter(company) {
            if (this.filter.companyType) {
                return company.cnpj.companyType == this.filter.companyType
            }
            return true
        },
        searchFilter(company) {
            const { name, tradingName, cnpj } = company

            if (this.search) {

                const nameAssert = name ? name.toLowerCase().includes(this.search.toLowerCase()) : false
                const tradingNameAssert = tradingName ? tradingName.toLowerCase().includes(this.search.toLowerCase()) : false
                const cnpjAssert = cnpj.cnpj.includes(removeMask(this.search)) || false

                return nameAssert
                    || tradingNameAssert
                    || cnpjAssert
            }
            return true
        },
        companyPartnerFilter(company) {
            if (this.filter.companyPartner) {
                return company.partners.includes(parseInt(this.filter.companyPartner))
            }
            return true
        }
    },
    async created() {
        const resetStore = {
            marketplace: true,
            fomentation: true,
            clients: true,
        }

        Cookies.set('resetStore', JSON.stringify(resetStore), {
            expires: 1,
            domain: process.env.VUE_APP_ROOT_DOMAIN
        })
        
        this.isLoading = true
        await getAllCnpjs()
        this.isLoading = false
    }

}
</script>

<style lang="scss" scoped>

</style>
